import React, { Component } from 'react';
import { Redirect } from "react-router";
import Loading from "./Parts/Loading";
import { APP_STEP_CONTACTS } from "../../constants";

class LastKnownStep extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: null,
            product_code: null,
            startNew: false,
        };

        this.getLastStep = this.getLastStep.bind(this);
        this.setApplData = this.setApplData.bind(this);
        this.getLastStep();
    }

    getLastStep() {
        axios.get('/api/process/' + this.props.application_token + '/last_step')
            .then(
                data => {
                    this.setApplData(data.data.data.last_step);
                },
                error => {
                     if(this.props.suggestion?.application.id !== null) {
                         this.setApplData(APP_STEP_CONTACTS);
                     } else {
                         this.setState({ startNew: true });
                     }
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
                this.setState({ startNew: true });
            });
    }

    setApplData(step) {
        this.setState({
            step: step,
            product_code: this.state.eshop_data?.product_code ?? null,
        })
    }

    getBaseUrl() {
        let base;

        switch (this.state.product_code) {
            case 'IP':
                base = '/ip/' + this.props.application_token + '/'
                break;
            default:
                base = '/' + this.props.application_token + '/process/';
        }

        return base;
    }

    render() {
        if (this.state.step !== null) {
            return <Redirect push={true} to={this.getBaseUrl() + this.state.step}/>
        }

        if (this.state.startNew) {
            return <Redirect push={true} to='/create_application' />
        }

        return (
            <Loading/>
        )
    }
}

export default LastKnownStep;
